/**
 * Tools — hub for Import Center, Export Center, Activity Logs.
 *
 * Replaces the old top-bar "Tools" dropdown. Each card deep-links to the
 * existing page rather than re-implementing the feature here.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Upload, Download, History } from 'lucide-react';

const tiles = [
  {
    to: '/import',
    icon: Upload,
    title: 'Import Center',
    desc: 'Bulk-import travellers, trips, and contacts from CSV/Excel files.',
    testid: 'tools-import',
  },
  {
    to: '/exports',
    icon: Download,
    title: 'Export Center',
    desc: 'Export travellers, trips, invoices, and accounting data to CSV.',
    testid: 'tools-exports',
  },
  {
    to: '/activity-logs',
    icon: History,
    title: 'Activity Logs',
    desc: 'PII access audit — every passport / PAN / Aadhaar reveal and bulk export (admin only).',
    testid: 'tools-activity-logs',
  },
];

const Tools = () => (
  <div className="max-w-5xl mx-auto py-10 px-6" data-testid="tools-page">
    <header className="mb-6">
      <h1 className="text-2xl font-semibold text-slate-900">Tools</h1>
      <p className="text-sm text-slate-500 mt-1">Operational utilities — import, export, and audit.</p>
    </header>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {tiles.map((t) => (
        <Link key={t.to} to={t.to} data-testid={t.testid}>
          <Card className="p-5 hover:border-emerald-300 hover:shadow-sm transition-all border-slate-200 h-full">
            <div className="h-10 w-10 rounded-lg bg-emerald-50 flex items-center justify-center mb-3">
              <t.icon className="h-5 w-5 text-emerald-600" />
            </div>
            <h2 className="text-base font-semibold text-slate-900 mb-1">{t.title}</h2>
            <p className="text-xs text-slate-500 leading-relaxed">{t.desc}</p>
          </Card>
        </Link>
      ))}
    </div>
  </div>
);

export default Tools;
